module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "createCode"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "codeBox"
  }, [_c('div', {
    staticClass: "download-cont"
  }, [_c('div', {
    staticClass: "dl-btn"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.configUrl
    }
  }, [_c('div', {
    staticClass: "btn-item pc-order",
    on: {
      "click": _vm.getZip
    }
  }, [_c('i', {
    staticClass: "iconfont icon-shoujishumadiannao"
  }), _vm._v(" "), _c('span', [_vm._v("购物点餐/呼叫客户端下载")])])]), _vm._v(" "), [_c('a', {
    attrs: {
      "href": 'https://images.huoxingy.com/service/' + _vm.curStoreId + '.zip'
    }
  }, [_vm._m(1)])]], 2), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "downINpc"
  }, [_vm._v("\n                    客户端 请在电脑查看并下载\n                ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://images.huoxingy.com/火星捕手点单系统安装包_V1.1.2.exe.zip"
    }
  }, [_c('div', {
    staticClass: "btn-item pos-for-tag"
  }, [_c('i', {
    staticClass: "iconfont icon-qiandai"
  }), _vm._v(" "), _c('span', [_vm._v("收银端下载")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-item service"
  }, [_c('i', {
    staticClass: "iconfont icon-shoujishumadiannao"
  }), _vm._v(" "), _c('span', [_vm._v("呼叫服务端下载")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qr-code",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "codes"
  }, [_c('div', {
    staticClass: "codeImg"
  }, [_c('div', {
    staticClass: "position-middle-center",
    attrs: {
      "id": "qrcode"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "codeNote"
  }, [_c('span', [_vm._v("微信点单二维码")]), _vm._v(" "), _c('div', {
    staticClass: "downmobile"
  }, [_vm._v("请在电脑下载二维码")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qr-code"
  }, [_c('div', {
    staticClass: "codes"
  }, [_c('div', {
    staticClass: "codeImg"
  }, [_c('div', {
    staticClass: "position-middle-center",
    attrs: {
      "id": "qrcodeForVip"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "codeNote"
  }, [_c('span', [_vm._v("店铺会员二维码")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-7e1b981c","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/indexRouters/createCode/createCode.vue
// module id = 966
// module chunks = 1